
import PageTitle from "../components/common/pageTitle";
import React, { useState, useEffect, useCallback } from "react";
import { makeStyles, Typography } from "@material-ui/core"
import HomeStyles from '../styles/Home.module.css'
import Banner from "../components/common/banner";
import axios from 'axios';
import Button from '@material-ui/core/Button';
import { useHistory } from "react-router-dom";
import api from '../libs/utils/axiosApiInstance'

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexWrap: 'wrap',
        flexDirection: 'column'
    },
    margin: {
        marginBottom: theme.spacing(3),
    },
    title: {
        fontWeight: 'bold',
        marginBottom: '2rem',
    },
    buttonConfirm: {
        background: '#FDB738',
        fontSize: '1.0rem',
        width: '100%',
        height: '45px',
    },
    buttonUpload: {
        background: '#FBBE66',
        color: '#FFFFFF',
        fontSize: '1.0rem',
        width: '100%',
        height: '54px',
    },

}));

function refreshPage() {
    window.location.reload();
}


export default function Branchs(props) {
    const query = new URLSearchParams(props.location.search);
    const history = useHistory();
    const classes = useStyles();
    let [isLoading, setLoading] = useState(false);
    const [branchs, setBranchs] = useState([]);


    useEffect(() => {

        getProfile();

    }, []);

    const getProfile = async () => {

        const res = await api.get(`/dashboard/front/branchs`);
        const _branchs = res.data.result;
        setBranchs(_branchs);
    }

    const linkGoogleMap = (lat, long) => {
        if(!lat && !long)  return;
        window.open(`https://www.google.com/maps/search/?api=1&query=${lat},${long}`);
    }


    return (
        <>




            <Banner>
                <div className="container">
                    <PageTitle title="" header="รายการศูนย์เมล็ดพันธุ์ข้าว" />
                    {/* <Breadcrumbs /> */}



                    <div className="row w-100">
                        <div className="col-md-12" >
                            <div className={HomeStyles.card} >
                                <div className="row">

                                    <div className="col-lg-12 col-md-12">

                                        <Typography variant="h5" className={classes.title} style={{
                                            marginBottom: '30px',

                                        }}>
                                            ข้อมูลศูนย์เมล็ดพันธุ์ข้าว
                                        </Typography>
                                        <table className="table table-bordered">
                                            <thead>
                                                <tr style={{
                                                    background: '#4472c4',
                                                    color: 'white'
                                                }}>
                                                    <th scope="col" className="text-center">ที่</th>
                                                    <th scope="col" className="text-center">ศูนย์เมล็ดพันธุ์ข้าว</th>
                                                    <th scope="col" className="text-center">ตำบล</th>
                                                    <th scope="col" className="text-center">อำเภอ</th>
                                                    <th scope="col" className="text-center">จังหวัด</th>
                                                    <th scope="col" className="text-center">ที่อยู่</th>
                                                    <th scope="col" className="text-center">เบอร์โทร</th>
                                                    <th scope="col" className="text-center">ที่ตั้ง</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {branchs.map((branch, index) =>
                                                    <tr style={{
                                                        background: '#e9ebf5',
                                                        verticalAlign: 'middle'
                                        
                                                    }} key={index}>
                                                        <td className="text-center">{index + 1}</td>
                                                        <td className="text-center">{branch.BranchName}</td>
                                                        <td className="text-center">{branch.District}</td>
                                                        <td className="text-center">{branch.SubDistrict}</td>
                                                        <td className="text-center">{branch.Province}</td>
                                                        <td className="text-center">{branch.Address}</td>
                                                        <td className="text-center">{branch.Tel}</td>
                                                        <td>
                                                        
                                                            <Button variant="contained" onClick={() => linkGoogleMap(branch.Latitude, branch.Longitude)}  className={classes.buttonConfirm} color="inherit" style={{
                                                                fontSize: '14px',
                                                                color: 'white'
                                                            }}
                                                            > แผนที่ </Button>

                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>






                        </div>
                    </div>

                </div>

            </Banner>










        </>
    )

}

